// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host.cs-nav-drop-down-opened:after {
  content: "";
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid #fff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  position: absolute;
  top: 46px;
  margin-left: 10px;
}
:host .trigger {
  color: white;
}
:host .to-do-badge {
  display: inline-block;
  padding: 0.3em 0.4em;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: bottom;
  border-radius: 1rem;
  background: var(--cs-primary-color);
  position: absolute;
  left: 13px;
  top: 11px;
}
:host .cs-nav-drop-down-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
:host .to-do {
  width: 18px;
  height: 18px;
}
:host .to-do-content {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 62px;
  bottom: auto;
  right: 0;
  color: #4b5b70;
  background: #fff;
  transition: width 0.25s, background 0.25s;
  box-shadow: -3px 4px 6px 0 rgba(196, 196, 196, 0.4);
}
:host .to-do-content .heading {
  padding: 1rem 1.5rem;
  display: flex;
}
:host .to-do-content .heading button {
  margin-left: auto;
}
:host .to-do-content .to-do-box {
  height: 500px;
  padding: 0 1.5rem;
}
:host .to-do-content .to-do-box p {
  color: #4b5b70;
  margin-bottom: 0.4rem;
}
:host .to-do-content .view-more {
  text-decoration: none;
  text-align: center;
  border-top: 1px solid #fafafa;
  margin: 0 auto;
  padding: 1rem 1.5rem;
}
:host .dot {
  height: 10px;
  width: 10px;
  background-color: var(--cs-primary-color);
  border-radius: 50%;
  display: inline-block;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
